import api from "./api";

export const getPatientProfile = () =>
  api.get("/patient/profiles/");

export const getProxyUsers = () =>
  api.get("/patient/proxies/");

export const addProxyUser = (data) =>
  api.post("/patient/proxies/", data);

export const getPrescriptions = () =>
  api.get("/pharmacy/prescriptions/");

export const getBillingRecords = () =>
  api.get("/billing/records/");

export const requestEMS = (data) =>
  api.post("/ems/requests/", data);

export const getEMSRequests = () =>
  api.get("/ems/requests/");

export const getOpticalServices = () =>
  api.get("/ophthalmology/examinations/");

export const getMyDiagnoses = (params = {}) =>
  api.get("/doctor/diagnoses/", { params });

export const getMedicalShares = () =>
  api.get("/doctor/medical-shares/");

export const createMedicalShare = (data) =>
  api.post("/doctor/medical-shares/", data);

export const revokeMedicalShare = (id) =>
  api.delete(`/doctor/medical-shares/${id}/`);

export const getDoctorProfiles = () =>
  api.get("/doctor/profiles/");

// Returns all verified pharmacy profiles — patients use this to set their preferred pharmacy.
export const getAllPharmacies = () =>
  api.get("/pharmacy/profiles/");

// PATCH patient profile (e.g. to update preferred_pharmacy).
export const updatePatientProfile = (id, data) =>
  api.patch(`/patient/profiles/${id}/`, data);

export const getPatientAppointments = () =>
  api.get("/patient/appointments/");

export const requestAppointment = (data) =>
  api.post("/patient/appointments/request/", data);

export const cancelAppointment = (id) =>
  api.post(`/patient/appointments/${id}/cancel/`);

export const getAvailableDoctors = () =>
  api.get("/patient/available-doctors/");

export const getPatientNotifications = () =>
  api.get("/patient/notifications/");

export const getPatientNotificationUnreadCount = () =>
  api.get("/patient/notifications/unread-count/");

export const markPatientNotificationsRead = () =>
  api.post("/patient/notifications/mark-read/");

export const markPatientNotificationRead = (id) =>
  api.post(`/patient/notifications/${id}/mark-read/`);

// ── Medical Share Consents ─────────────────────────────────────────────────────
export const getShareConsents = () =>
  api.get("/patient/share-consents/");

export const shareRecords = (data) =>
  api.post("/patient/share-consents/share/", data);

export const revokeShareConsent = (id) =>
  api.post(`/patient/share-consents/${id}/revoke/`);

export const getAvailablePharmacies = (rxId) =>
  api.get(`/pharmacy/prescriptions/${rxId}/available-pharmacies/`);
